const Collection = {
  MARITAL_STATUS: "maritalStatus",
  MOTHER_TONGUE: "motherTongue",
  COMPLEXION: "complexion",
  BODY_TYPE: "bodyType",
  DIET: "diet",
  HABIT_TYPE: "habitType",
  JOB_TYPE: "jobType",
  INCOME: "income",
  EDUCATION: "education",
  EMPLOYED_IN: "employedIn",
  USERS: "users",
  PARTNER_PREFERENCE: "preference",
  RELIGION: "religion",
  COMMUNITY: "community",
  CASTE: "caste",
  HEIGHT: "height",
  DISABILITY: "disability",
  FAMILY_STATUS: "familyStatus",
  FAMILY_VALUE: "familyValue",
  FAMILY_TYPE: "familyType",
  HOUSE_TYPE: "houseType",
  MOON_SIGN: "moonSign",
  CREATED_BY: "createdBy",
  COUNTRY: "country",
  STATE: "state",
  PRIVACY_SETTING: "privacy",
  PROFILE_VIEWS: "profileViews",
  PROFILE_LIKES: "profileLikes",
  NOTIFICATIONS: "notifications",
  INTERESTS: "profileInterests",
  SHORTLISTS: "profileShortlists",
  SAVES: "profileSaves",
  FAVORITES: "profileFavorites",
  CONNECTS: "profileConnects",
  MESSAGING: "messaging",
  CHAT_MESSAGES: "messages",
  USER_CONVERSTATIONS: "conversations",
  GALLERY: "images",
  PHONE_NUMBER: "phoneNumber"
};

export default Collection;



// WEBPACK FOOTER //
// ./src/_collections/index.js